<template>
	<div class="admin-back">
		<el-menu default-active="0" class="el-menu-vertical-demo" :collapse="isCollapsed">
			<el-icon size="4em" class="header-svg">
				<img :src="VRSVG" @click="isCollapsed = !isCollapsed" alt="VR Icon" class="head-icon" />
			</el-icon>
			<el-menu-item index="1" @click="$router.push('/userpanel/studentonclass'); title = '在学课程'; isHome = false">
				<el-icon :size="60">
					<img :src="mapSVG" alt="on Icon" class="menu-icon" />
				</el-icon>
				<template #title><span>在学课程</span></template>
			</el-menu-item>

			<el-menu-item index="2" @click="$router.push('/userpanel/studentclass'); title = '所有课程'; isHome = false">
				<el-icon :size="60">
					<img :src="courseSVG" alt="all Icon" class="menu-icon" />
				</el-icon>
				<template #title><span>所有课程</span></template>
			</el-menu-item>
			<el-menu-item index="3" @click="$router.push('/userpanel/studentpublicresource'); title = '公共资料'; isHome = false">
				<el-icon :size="60">
					<img :src="deviceSVG" alt="Resource Icon" class="menu-icon" />
				</el-icon>
				<template #title>
					<span>公共资料</span>
				</template>
			</el-menu-item>
		</el-menu>

		<el-container>
			<el-header>
				<h1 :class="{ is_home: isHome }">{{ title }}</h1>
				<div class="adminUser">
					<el-button type="primary" round style="width: 140px; margin-right: 20px; display: flex; justify-content: center; align-items: center" @click="goToEvaluation">综合评测（教师用）</el-button>
					<el-popover placement="top-start" :width="200" trigger="hover">
						<template #reference>
							<span>信息</span>
						</template>
						<div class="user-button">
							<p class="name">姓名：{{ listfrom.name }}</p>
							<p class="user">学号：{{ listfrom.user }}</p>
							<p class="faculty">学院：{{ listfrom.faculty }}</p>
							<p class="major">专业：{{ listfrom.major }}</p>
						</div>
					</el-popover>

					<el-popover placement="top-start" :width="200" trigger="hover">
						<template #reference>
							<span>个人</span>
						</template>
						<div class="user-button">
							<el-button type="danger" round @click="passwordModify">修改密码</el-button>
						</div>
						<div class="user-button">
							<el-button type="danger" round @click="logout">登出</el-button>
						</div>
					</el-popover>

				</div>
			</el-header>
			<el-main><router-view></router-view></el-main>
		</el-container>

		<el-dialog title="修改密码" v-model="modifyDialogVisible" width="400px" :show-close="false">
			<el-form :model="modifyFormData">
				<el-form-item label="旧密码" prop="oldPassword">
					<el-input v-model="modifyFormData.oldPassword" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="newPassword">
					<el-input v-model="modifyFormData.newPassword" placeholder="请输入"></el-input>
				</el-form-item>
			</el-form>
			<span class="dialog-footer">
				<el-button @click="modifyDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitModifyForm">确 定</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
import { defineComponent, ref } from 'vue';
import VRSVG from '@/assets/icons/VR.svg'
import homeSVG from '@/assets/icons/home.svg'
import userSVG from '@/assets/icons/user.svg'
import cameraSVG from '@/assets/icons/camera.svg'
import deviceSVG from '@/assets/icons/device.svg'
import mapSVG from '@/assets/icons/map.svg'
import courseSVG from '@/assets/icons/course.svg'
import { ElNotification } from 'element-plus'
import '@/styles/AdminPanel.css';


export default defineComponent({
	data() {
		return {
			VRSVG,
			homeSVG,
			userSVG,
			deviceSVG,
			cameraSVG,
			mapSVG,
			courseSVG,
			isCollapsed: true,
			isHome: true,
			title: "课程管理平台",

			// 修改密码
			modifyDialogVisible: false,
			modifyFormData: {
				oldPassword: '',
				newPassword: '',
			},


		}
	},
	mounted() {
		// 组件挂载后调用getUserDatas方法
		this.getUserDatas();
	},
	setup() {
		const listfrom = ref({}); // 使用一个空对象作为初始值
		return {
			listfrom,
		};
	},
	methods: {
		goToEvaluation() {
			window.open('http://111.35.64.52:30174/', '_blank');
		},
		async getUserDatas() {
			try {
				const response = await this.$axios.post("/api/self/info");
				this.listfrom = response.data; // 更新响应式数据
			} catch (error) {
				console.error("An error occurred while fetching the user data:", error);
			}
		},

		logout() {
			this.$router.push({ name: 'loginview' });
			this.backendlogout;
		},
		async backendlogout() {
			try {
				const response = await this.$axios.post(
					'/api/logout',
				);

				
				console.log(response)
			} catch (error) {
				console.error('登出失败', error);
			}
		},
		// 修改密码
		passwordModify() {
			this.modifyDialogVisible = true;
		},
		async submitModifyForm() {
			try {
				const postData = {
					passwordOld: this.modifyFormData.oldPassword,
					passwordNew: this.modifyFormData.newPassword,
				}

				const response = await this.$axios.post('/api/self/pass', postData)
				if (response.code == 0) {
					ElNotification({
						title: '提示',
						message: '修改成功',
						type: 'info',
					})
				}

				this.modifyDialogVisible = false

				this.modifyFormData = {  // 重置表单数据
					oldPassword: '',
					newPassword: '',
				};
			} catch (error) {
				console.error('Error modifying password:', error)
			}
		},
	}
});
</script>

<style scoped>
.is_home {
	background-color: transparent;
}

.user-button {
	display: flex;
	gap: 16px;
	flex-direction: column;
	padding: 5px;
}

.dialog-content {
	margin-bottom: 30px;
}

.dialog-information {
	margin-bottom: 30px;
	border: 1px solid #ccc;
	border-radius: 5px;
}

.dialog-information-text {
	margin: 10px;
	font-size: 15px;
}

:deep .el-dialog__body {
	padding: 10px 20px;
}

:deep .el-dialog__header {
	margin-right: 0px;
}

.text-wrapper {
	word-wrap: break-word;
	word-break: break-all;
	user-select: text;
	padding-bottom: 20px;
}
</style>